export enum ActionResponseStatusAi {
    COMPLETE = 'complete',
    EXECUTING = 'executing',
    IN_PROGRESS = 'inProgress',
    CANCELLED = 'cancelled',
}
